module.exports = __webpack_public_path__ + "static/media/slimakova.7f236353.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/slimakova.jpg
// module id = 498
// module chunks = 0